/**
 * Noise utilities for procedural terrain generation
 * Migrated from test.html prototype
 */

/**
 * Hash function for 2D coordinates
 * Returns a pseudo-random value in [0, 1]
 */
export function hash2(x: number, z: number): number {
  let n = x * 374761393 + z * 668265263;
  n = (n ^ (n >> 13)) * 1274126177;
  n = (n ^ (n >> 16)) >>> 0;
  return n / 4294967295;
}

/**
 * Smooth interpolation function
 */
export function smoothstep(t: number): number {
  return t * t * (3 - 2 * t);
}

/**
 * Value noise for 2D coordinates
 */
export function valueNoise(x: number, z: number): number {
  const x0 = Math.floor(x);
  const z0 = Math.floor(z);
  const x1 = x0 + 1;
  const z1 = z0 + 1;

  const fx = x - x0;
  const fz = z - z0;

  const a = hash2(x0, z0);
  const b = hash2(x1, z0);
  const c = hash2(x0, z1);
  const d = hash2(x1, z1);

  const ux = smoothstep(fx);
  const uz = smoothstep(fz);

  const ab = a + (b - a) * ux;
  const cd = c + (d - c) * ux;

  return ab + (cd - ab) * uz;
}

/**
 * Fractal Brownian Motion
 * Combines multiple octaves of noise for natural-looking terrain
 */
export function fbm(x: number, z: number, octaves: number = 4): number {
  let amplitude = 0;
  let frequency = 1;
  let weight = 1;
  let sumWeight = 0;

  for (let i = 0; i < octaves; i++) {
    amplitude += valueNoise(x * frequency, z * frequency) * weight;
    sumWeight += weight;
    frequency *= 0.5;
    weight *= 0.55;
  }

  return amplitude / sumWeight;
}
